import React, { useMemo, useState } from "react"
import ExportExcel from "components/Excelconvert/ExportExcel"

import { useSelector, useDispatch } from "react-redux"
import {
  CardBody,
  Card,
  Row,
  Col,
  CardTitle,
  Badge,
  Modal,
  UncontrolledTooltip,
  Button,
  Container,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"

import moment from "moment"
import { FaEnvelope, FaClock } from "react-icons/fa";

//import components
import TableContainer from "components/Common/TableContainer"
import { useEffect } from "react"

// slice
import {
  TicketBookedHistory,
  resetVenue,
} from "toolkitStore/eventMSlice/VenueSlice"
import { sendBookingMail } from "toolkitStore/eventMSlice/SeatAllocationSlice"

function TicketBooked(props) {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const event_id_c = JSON.parse(localStorage.getItem("event_id"))
  // console.log("event_id", event_id_c)
  const venue_id_c = JSON.parse(localStorage.getItem("venue_id"))
  // console.log("venue_id", venue_id_c)

  const { TicketBookedDetails, VenueisSuccessfully } = useSelector(
    state => state.VenueReducer
  )
const FREE_EVENT_EXPORT_FIELDS = [
  "short_veg_dec",
  "_id",
  "master_event_id",
  "master_venue_id",
  "sats_member_id",
  "member_type",
  "transaction_id",
  "payer_id",
  "event_name",
  "venue_name",
  "event_date",
  "venue_date",
  "email",
  "firstname",
  "lastname",
  "mobile",
  "net_amount",
  "veg_adult_count",
  "veg_child_count",
  "nonveg_adult_count",
  "nonveg_child_count",
  "event_type",
  "includeTicketType",
  "visited",
  "ticket_generated",
  "ticket_payment_status",
  "barcode",
  "createdAt",
  "updatedAt",
  "__v",
];



   const { newEventList } = useSelector(state => state.EventReducer)
    const currentEvent = newEventList?.find(ev => ev._id === event_id_c?.EventId)

 

    console.log(`log for  particular event ${currentEvent?.eventTypeId}`)
  useEffect(() => {
    dispatch(TicketBookedHistory(venue_id_c.VenueId))

    dispatch(resetVenue())
  }, [])
 
 



  const columns = useMemo(
    () => [
      {
        Header: "Member ID",
        accessor: "sats_member_id",
        Cell: cellProps => (
          <ul className="list-unstyled hstack gap-3 mb-0 text-center">
            <li
              className={
                cellProps.row.original.sats_member_id
                  ? "text-dark"
                  : "text-danger"
              }
            >
              {cellProps.row.original.sats_member_id
                ? cellProps.row.original.sats_member_id
                : "Non Member"}
            </li>
          </ul>
        ),
      },
      {
        Header: "First Name",
        accessor: "firstname",
      },
      {
        Header: "Last Name",
        accessor: "lastname",
      },


      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Payment Date",
        accessor: "createdAt",
        Cell: cellProps => {
          return (
            <div>
              {moment
                .parseZone(cellProps.row.original.createdAt)
                .format("MM/DD/YYYY")}
            </div>
          )
        },
      },
      {
        Header: "Tansaction ID",
        accessor: "transaction_id",
      },

      {
        Header: "Adult",
        accessor: "adult_count",
      },
      {
        Header: "Child",
        accessor: "child_count",
      },
       {
        Header: "veg",
        accessor: "veg_count",
      },
      {
        Header: "non-veg",
        accessor: "nonveg_count",
      },
 
      {
        Header: "Amount",
        accessor: "net_amount",
        Cell: cellProps => {
          return <div>$ {cellProps.row.original.net_amount}</div>
        },
      },
      {
        Header: "Payment Status",
        accessor: "payment_status",
        Cell: cellProps => {
          // console.log("cellProps.row.original", cellProps.row.original)
          return (
            <ul className="list-unstyled mb-0">
              <div
                className={
                  cellProps.row.original.ticket_payment_status === "initiated"
                    ? "badge badge-soft-secondary"
                    : cellProps.row.original.ticket_payment_status === "failed"
                      ? "badge badge-soft-danger"
                      : "badge badge-soft-success"
                }
              >
                {cellProps.row.original.ticket_payment_status === "initiated"
                  ? "Initiated"
                  : cellProps.row.original.ticket_payment_status === "failed"
                    ? "Failed"
                    : "Success"}
              </div>
            </ul>
          )
        },
      },



 {
  Header: "Send Mail",
  Cell: ({ row }) => {
    const payer = row.original;
    const isSuccess = payer.ticket_payment_status === "success";

    return (
      <Button
        // color="primary"
        size="sm"
        disabled={!isSuccess} // Disable if not success
        title={
          isSuccess
            ? `Send mail to ${payer.email}`
            : "Mail can be sent only after successful payment"
        }
        onClick={() => {
          if (isSuccess && window.confirm(`Send mail to ${payer.email}?`)) {
            
             dispatch(sendBookingMail({ payer_id: payer._id, email: payer.email }));
          }
        }} style={{ backgroundColor: "white",borderColor:"white"  }}
      >
        {/* {isSuccess ? "Send Mail" : "Pending"} */}
        
         {isSuccess ? (
    <FaEnvelope style={{ color: "#0fdc27", fontSize: "18px" }} />
  ) : (
    <FaClock style={{ color: "gray", fontSize: "18px" }} />
  )}
      </Button>
    );
  },
},


    ],
    []
  )

  const normalColumns = [
  { Header: "Adult", accessor: "adult_count" },
  { Header: "Child", accessor: "child_count" },
  { Header: "Veg", accessor: "veg_count" },
  { Header: "Non-Veg", accessor: "nonveg_count" },
];

const freeAdultChildFoodColumns = [
  { Header: "Veg Adult", accessor: "veg_adult_count" },
  { Header: "Veg Child", accessor: "veg_child_count" },
  { Header: "Non-Veg Adult", accessor: "nonveg_adult_count" },
  { Header: "Non-Veg Child", accessor: "nonveg_child_count" },
];

const freePaidFoodColumns = [
  { Header: "Veg", accessor: "veg_count" },
  { Header: "Non-Veg", accessor: "nonveg_count" },
];
const firstBooking = TicketBookedDetails?.[0];

const isFreeEvent = firstBooking?.event_type === "FREE";

const showAdultChildFoodSplit =
  isFreeEvent && firstBooking?.includeTicketType === "ADULT_CHILD";

const showOnlyVegNonVeg =
  isFreeEvent &&
  firstBooking?.freeFoodOption === "WITH_FOOD" &&
  firstBooking?.freeFoodType === "PAID_FOOD";

  const totals = useMemo(() => {
  return TicketBookedDetails.reduce(
    (acc, item) => {
      acc.adult += item.adult_count || 0;
      acc.child += item.child_count || 0;

      acc.vegAdult += item.veg_adult_count || 0;
      acc.vegChild += item.veg_child_count || 0;

      acc.nonVegAdult += item.nonveg_adult_count || 0;
      acc.nonVegChild += item.nonveg_child_count || 0;

      return acc;
    },
    {
      adult: 0,
      child: 0,
      vegAdult: 0,
      vegChild: 0,
      nonVegAdult: 0,
      nonVegChild: 0,
    }
  );
}, [TicketBookedDetails]);

const exportExcelData = useMemo(() => {
  if (!TicketBookedDetails?.length) return [];

  // FREE event → filter fields
  if (isFreeEvent) {
    return TicketBookedDetails.map(item =>
      FREE_EVENT_EXPORT_FIELDS.reduce((acc, key) => {
        acc[key] = item[key] ?? "";
        return acc;
      }, {})
    );
  }

  // PAID event → full data
  return TicketBookedDetails;
}, [TicketBookedDetails, isFreeEvent]);
const columns1 = useMemo(() => {
  const baseColumns = [
    {
      Header: "Member ID",
      accessor: "sats_member_id",
      Cell: ({ row }) =>
        row.original.sats_member_id || "Non Member",
    },
    { Header: "First Name", accessor: "firstname" },
    { Header: "Last Name", accessor: "lastname" },
    { Header: "Email", accessor: "email" },
    {
      Header: "Payment Date",
      accessor: "createdAt",
      Cell: ({ row }) =>
        moment(row.original.createdAt).format("MM/DD/YYYY"),
    },
    { Header: "Transaction ID", accessor: "transaction_id" },
  ];

  let bookingColumns = [];

  if (showAdultChildFoodSplit) {
    bookingColumns = freeAdultChildFoodColumns;
  } else if (showOnlyVegNonVeg) {
    bookingColumns = freePaidFoodColumns;
  } else {
    bookingColumns = normalColumns;
  }

  return [
    ...baseColumns,
    ...bookingColumns,
    {
      Header: "Amount",
      accessor: "net_amount",
    },
    {
      Header: "Payment Status",
      accessor: "ticket_payment_status",
    },

     {
  Header: "Send Mail",
  Cell: ({ row }) => {
    const payer = row.original;
    const isSuccess = payer.ticket_payment_status === "success";

    return (
      <Button
        // color="primary"
        size="sm"
        disabled={!isSuccess} // Disable if not success
        title={
          isSuccess
            ? `Send mail to ${payer.email}`
            : "Mail can be sent only after successful payment"
        }
        onClick={() => {
          if (isSuccess && window.confirm(`Send mail to ${payer.email}?`)) {
            
             dispatch(sendBookingMail({ payer_id: payer._id, email: payer.email }));
          }
        }} style={{ backgroundColor: "white",borderColor:"white"  }}
      >
        {/* {isSuccess ? "Send Mail" : "Pending"} */}
        
         {isSuccess ? (
    <FaEnvelope style={{ color: "#0fdc27", fontSize: "18px" }} />
  ) : (
    <FaClock style={{ color: "gray", fontSize: "18px" }} />
  )}
      </Button>
    );
  },
},
  ];
}, [
  showAdultChildFoodSplit,
  showOnlyVegNonVeg,
]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Utility" breadcrumbItem="Booked Information" />

          <Row className="">
            <Card>
              <CardBody className="border-botton">
                <div className="d-flex align-items-center">
                  <h5 className="mb-1 card-title flex-grow-1 text-primary">
                    {event_id_c.EventName + " / " + venue_id_c.VenueName}
                  </h5>
                  <div className="mb-1 flex-shrink-0">
                    {/* <ExportExcel
                      excelData={TicketBookedDetails}
                      fileName={"TicketsSales"}
                    /> */}
                    <ExportExcel
                      // excelData={TicketBookedDetails}
                      excelData={
    isFreeEvent
      ? exportExcelData ?? []
      : TicketBookedDetails ?? []
  }
                      fileName={`Booking Details ${venue_id_c.VenueName}`}
                    />

                    <Link to="/upcomingevents" className="btn btn-secondary me-1">
                      Back
                    </Link>
                    <Link
                      to="#!"
                      onClick={() => {
                        /*  dispatch(fetchServices(userInformation.m_company_id)) */
                      }}
                      className="btn btn-light me-1"
                    >
                      <i className="mdi mdi-refresh"></i>
                    </Link>
                  </div>
                </div>
                <Row>
                  <div className="container-fluid">
                    <TableContainer
                      columns={columns1}
                      data={TicketBookedDetails}
                      isGlobalFilter={true}
                      isAddOptions={false}
                      customPageSize={30}
                      isJobListGlobalFilter={false}
                    // className="custom-header-css"
                    />
                    <Row className="mt-3">
  {/* <Col md="12">
    <Card className="border">
      <CardBody className="py-2">

      <Row className="text-center">

   {!isFreeEvent && (
    <>
      <Col md="3">
        <h6 className="mb-1 text-muted">Total Adults</h6>
        <h5 className="text-primary">{totals.adult}</h5>
      </Col>

      <Col md="3">
        <h6 className="mb-1 text-muted">Total Children</h6>
        <h5 className="text-primary">{totals.child}</h5>
      </Col>
    </>
  )}

   <Col md="3">
    <h6 className="mb-1 text-muted">Veg  </h6>
    <h5 className="text-success">
      Adult :{totals.vegAdult} Child  :{totals.vegChild}
    </h5>
  </Col>

  <Col md="3">
    <h6 className="mb-1 text-muted">Non-Veg  </h6>
    <h5 className="text-danger">
      Adult :{totals.nonVegAdult}  Child :{totals.nonVegChild}
       
    </h5 >
   </Col>

</Row>


        <hr className="my-2" />

        <Row className="text-center">
          <Col>
            <h6 className="mb-1 text-muted">Total Food Count</h6>
            <h5 className="fw-bold">
              Veg: {totals.vegAdult + totals.vegChild} | Non-Veg:{" "}
              {totals.nonVegAdult + totals.nonVegChild}
            </h5>
          </Col>
        </Row>

      </CardBody>
    </Card>
  </Col> */}
</Row>

                  </div>
                </Row>
                {TicketBookedDetails.length > 30 ? (
                  <Row>
                    <Col xs="12">
                      <div className="text-center my-3">
                        <Link to="#" className="text-success">
                          <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                          Load more
                        </Link>
                      </div>
                    </Col>
                  </Row>
                ) : null}
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default TicketBooked
